import { cn } from "@newxsystems/shared";
import { resolveTootPrimitive } from "../../../../client";
import type { ITootActionsProps, TootActionVariant } from "./TootActions.props";

const variantClasses: Record<TootActionVariant, string> = {
  primary: "toot-button toot-button-primary",
  secondary: "toot-button toot-button-secondary",
  outline: "toot-button toot-button-outline",
  ghost: "toot-button toot-button-ghost",
  link: "toot-button-link",
};

const alignmentClasses = {
  left: "justify-start",
  center: "justify-center",
  right: "justify-end",
};

const getSafeRel = (target: string) => (target === "_blank" ? "noopener noreferrer" : undefined);

export const TootActions = ({ actions, alignment = "left", className }: ITootActionsProps) => {
  const Link = resolveTootPrimitive("Link");
  const items = actions ?? [];

  if (items.length === 0) {
    return null;
  }

  return (
    <div
      className={cn("flex flex-wrap gap-3", alignmentClasses[alignment], className)}
      data-toot-actions=""
    >
      {items.map((action, index) => {
        const classNames = variantClasses[action.style];

        return (
          <Link
            aria-label={action.ariaLabel}
            className={classNames}
            href={action.href}
            key={`${action.href}-${index}`}
            rel={getSafeRel(action.target)}
            target={action.target}
            title={action.ariaLabel}
          >
            <span>{action.text}</span>
            {action.style === "link" ? null : (
              <span aria-hidden="true" className="font-black">
                →
              </span>
            )}
          </Link>
        );
      })}
    </div>
  );
};

TootActions.displayName = "Layout::TootActions";
